<template>
    <div id="container" type="vinsurance">
        <div class="page page-insurance"  v-ga:request="{pageType:'vinsurance', state: {}}" v-ga:page="{pageType:'vinsurance', glb: glb, state: {}}">
            <mvtHeader />
            <mvtWelcome>
                <template v-slot:img>
                    <img :src="glb.cdnUrl + 'images/desktop/preapproval/preapproval-bg.webp'" alt="Welcome Home Insurance Page" fetchpriority="auto"/>
                </template>
                <template v-slot:content>
                    <h1 class="f0 text-bold"> Get a Home Insurance Quote</h1>
                    <mvtInputGeo class="large" ref="addressInput" v-model="geoInfo" :placeholder="glb.isPhone ? 'Enter Address' : 'Enter a Home Address'">Get Quotes</mvtInputGeo>
                </template>
            </mvtWelcome>

            <section class="inline large">
                <div class="grid gap-3 xs-grid-cols-1 fixed fixed-max-sm">
                    <h2 class="text-center">
                        <b class="f3 text-bold">Frequently Asked Questions</b>
                    </h2>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <mortgageTools :id="glb.pageType"></mortgageTools>

            <section v-if="tag" class="inline large">
                <div class="grid gap-3 xs-grid-cols-1 fixed fixed-max-sm ">
                    <div class="text-center">
                        <h2 class="f3 text-bold">Related Articles</h2>
                    </div>
                    <mvtArticle :tag="tag"/>
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-insurance.js"></script>
